import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Settings from "@/pages/Settings";
import PlansLanding from "@/pages/PlansLanding";
import PlansSuccess from "@/pages/PlansSuccess";
import ClientReport from "@/pages/ClientReport";
import ClaimPass from "@/pages/ClaimPass";

function Shell() {
    const location = useLocation();
    // Detect Emergent Google Auth callback (session_id in URL hash) synchronously
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/plans" element={<PlansLanding />} />
            <Route path="/plans/success" element={<PlansSuccess />} />
            <Route path="/c/:token" element={<ClientReport />} />
            <Route path="/claim/:slug/:cycle" element={<ClaimPass />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/assessment"
                element={
                    <ProtectedRoute>
                        <Assessment />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/report/:id"
                element={
                    <ProtectedRoute>
                        <Report />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute adminOnly>
                        <Admin />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/settings"
                element={
                    <ProtectedRoute>
                        <Settings />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Landing />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <div className="min-h-screen flex flex-col">
                    <Header />
                    <main className="flex-1">
                        <Shell />
                    </main>
                    <Footer />
                </div>
            </AuthProvider>
        </BrowserRouter>
    );
}
